var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"receipt-list tab-table p-2"},[_c('BidsTable',{attrs:{"exclude-search-fields":['bidder_uuid'],"hide-bid-creation":"","exclude-columns":['bidder']}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }